import { Action } from '@ngrx/store';

import { ListOwnerAndIsPublisher } from '../metadata/owner-with-list-publisher-flag';

export enum ListOwnersEditorActionTypes {
  LIST_OWNERS_EDITOR_SHOW_MODAL = '[List owners editor] Show modal',
  LIST_OWNERS_EDITOR_HIDE_MODAL = '[List owners editor] Hide modal',
  LIST_OWNERS_EDITOR_SAVE = '[List owners editor] Save list owners',
  LIST_OWNERS_EDITOR_SAVE_SUCCEEDED = '[List owners editor] Save list owners succeeded',
  LIST_OWNERS_EDITOR_SAVE_FAILED = '[List owners editor] Save list owners failed',
}

export interface ListIdPayload {
  listId: string;
}

export class ListOwnersEditorShowModalAction implements Action {
  readonly type = ListOwnersEditorActionTypes.LIST_OWNERS_EDITOR_SHOW_MODAL;

  constructor(public payload: ListIdPayload) {}
}

export class ListOwnersEditorHideModalAction implements Action {
  readonly type = ListOwnersEditorActionTypes.LIST_OWNERS_EDITOR_HIDE_MODAL;
}

interface ListOwnersPayload extends ListIdPayload {
  ownersWithPublisherFlags: ListOwnerAndIsPublisher[];
}

export class ListOwnersEditorSaveAction implements Action {
  readonly type = ListOwnersEditorActionTypes.LIST_OWNERS_EDITOR_SAVE;

  constructor(public payload: ListOwnersPayload) {}
}

export class ListOwnersEditorSaveSucceededAction implements Action {
  readonly type = ListOwnersEditorActionTypes.LIST_OWNERS_EDITOR_SAVE_SUCCEEDED;

  constructor(public payload: ListOwnersPayload) {}
}

export interface ListOwnersSaveFailedPayload extends ListOwnersPayload {
  error: any;
}

export class ListOwnersEditorSaveFailedAction implements Action {
  readonly type = ListOwnersEditorActionTypes.LIST_OWNERS_EDITOR_SAVE_FAILED;

  constructor(public payload: ListOwnersSaveFailedPayload) {}
}

export type ListOwnersEditorActions =
  | ListOwnersEditorShowModalAction
  | ListOwnersEditorHideModalAction
  | ListOwnersEditorSaveAction
  | ListOwnersEditorSaveSucceededAction
  | ListOwnersEditorSaveFailedAction;
